import { LIMITED_RANKS } from 'constants/enum';

export function isAgentRankLimited(rank) {
  return LIMITED_RANKS.has(rank);
}

/**
 * Whether `agentId` is the current user's own account, which can never be
 * offboarded. While viewing as an agent, two accounts count as "self": the
 * impersonated agent (`currentUserId`, i.e. zohoData.id) and the real backup
 * account restored on exit (`mainZohoId`). Outside view-as mode only
 * `currentUserId` is checked.
 */
export function isSelfAgent({
  agentId,
  currentUserId,
  mainZohoId,
  viewAsAgent
}) {
  if (agentId == null || agentId === '') return false;
  const target = String(agentId);
  if (target === String(currentUserId)) return true;
  if (viewAsAgent && mainZohoId && target === String(mainZohoId)) return true;
  return false;
}

/**
 * Helper text shown when the offboard button is disabled because the row is
 * the current user. Distinguishes the impersonated agent from the real
 * (backup) account while viewing as an agent.
 */
export function getCannotOffboardSelfMessage({
  agentId,
  currentUserId,
  viewAsAgent
}) {
  if (viewAsAgent && String(agentId) === String(currentUserId)) {
    return "You can't offboard the agent you're viewing as";
  }
  return "You can't offboard your own account";
}
